import React from "react";
import SystemSettingsTable from "./SystemSettingsTable";
import RoleLogicTable from "./RoleLogicTable";
import ManagersTable from "./ManagersTable";

// Компонент для відображення вкладки "Налаштування"
const SettingsTab = () => {
  return (
    <div className="settings-tab">
      <div className="botsettings-container">
        <div className="botsettings-content">
          <ManagersTable />
        </div>
      </div>

      <div className="botsettings-container">
        <div className="botsettings-content">
          <SystemSettingsTable />
        </div>

        <div className="botsettings-content">
          <RoleLogicTable />
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;
